import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'RDF-Schema' ontology */
export const ns = createNS("http://www.w3.org/2000/01/rdf-schema#");
/** The class resource, everything. */
export const Resource = ns("Resource");
/** The class of classes. */
export const Class = ns("Class");
/** The class of literal values, eg. textual strings and integers. */
export const Literal = ns("Literal");
/** The class of RDF containers. */
export const Container = ns("Container");
/** The class of container membership properties, rdf:_1, rdf:_2, ...,
                    all of which are sub-properties of 'member'. */
export const ContainerMembershipProperty = ns("ContainerMembershipProperty");
/** The class of RDF datatypes. */
export const Datatype = ns("Datatype");
/** The subject is a subclass of a class. */
export const subClassOf = ns("subClassOf");
/** The subject is a subproperty of a property. */
export const subPropertyOf = ns("subPropertyOf");
/** A description of the subject resource. */
export const comment = ns("comment");
/** A human-readable name for the subject. */
export const label = ns("label");
/** A domain of the subject property. */
export const domain = ns("domain");
/** A range of the subject property. */
export const range = ns("range");
/** Further information about the subject resource. */
export const seeAlso = ns("seeAlso");
/** The defininition of the subject resource. */
export const isDefinedBy = ns("isDefinedBy");
/** A member of the subject resource. */
export const member = ns("member");
export default {
    /** Function to create arbitrary terms within the 'RDF-Schema' ontology */
    ns,
    /** The class resource, everything. */
    Resource,
    /** The class of classes. */
    Class,
    /** The class of literal values, eg. textual strings and integers. */
    Literal,
    /** The class of RDF containers. */
    Container,
    /** The class of container membership properties, rdf:_1, rdf:_2, ...,
                        all of which are sub-properties of 'member'. */
    ContainerMembershipProperty,
    /** The class of RDF datatypes. */
    Datatype,
    /** The subject is a subclass of a class. */
    subClassOf,
    /** The subject is a subproperty of a property. */
    subPropertyOf,
    /** A description of the subject resource. */
    comment,
    /** A human-readable name for the subject. */
    label,
    /** A domain of the subject property. */
    domain,
    /** A range of the subject property. */
    range,
    /** Further information about the subject resource. */
    seeAlso,
    /** The defininition of the subject resource. */
    isDefinedBy,
    /** A member of the subject resource. */
    member
};
